module.exports = __webpack_public_path__ + "images/saaremaa/routes/pointers/TAL-AEG-TAL.png";